import React, { useEffect, useState } from "react";
import LandingJazzCash from "../components/Landing";

import {
  checkJCUserService,
  getArtworkService,
  getJcPlanService,
} from "../services/LandingjcService";
import { Config } from "../constants/Config";
import { useSearchParams } from "react-router-dom";
import defaultArtwork from "../Assets/Images/landingJcArtwork.webp";
import { headerEnrichmentService } from "../services/LandingjcService";

let utm_source = "";

const LandingJazzCashScreen = () => {
  const [searchParams] = useSearchParams();
  const [msisdn, setMsisdn] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isPrivacyPolicyChecked, setIsPrivacyPolicyChecked] = useState(true);
  const [artworkUrl, setArtworkUrl] = useState<string>(defaultArtwork);
  const [isArtworkLoading, setIsArtworkLoading] = useState(true);
  const [pricePoint, setPricePoint] = useState<string>("");
  const [disclaimerText, setDisclaimerText] = useState<string>("");
  const [resolvedPlanId, setResolvedPlanId] = useState<string>("");
  const [isLoading, setIsLoading] = useState(true);

  // const planId = searchParams.get("planId") || "1";
  const plan_id = searchParams.get("plan_id") || "";
  utm_source = searchParams.get("utm_source") ?? "";
  const identifier = "sekho";
  const param_name = searchParams.get("utm_campaign") || "";

  useEffect(() => {
    fetchMsisdn();
    fetchArtwork();
  }, []);

  const fetchArtwork = async () => {
    if (!identifier || !param_name) {
      setIsArtworkLoading(false);
      return;
    }
    try {
      const response = await getArtworkService(identifier, param_name);
      if (response.success && response.data.url) {
        setArtworkUrl(response.data.url);
      }
    } catch (error) {
      // keep default artwork on any error (404, rate limit, network)
    } finally {
      setIsArtworkLoading(false);
    }
  };

  const fetchPlan = async (_msisdn?: string) => {
    try {
      const response = await getJcPlanService(plan_id);
      if (!response.result) {
        console.log("error while fetching plan: no result returned");
        setErrorMessage("Something went wrong please try again later.");
        setIsLoading(false);
        return;
      }
      const { id, price, billingType } = response.result;
      setResolvedPlanId(id.toString());
      const billingUnitMap: Record<string, string> = {
        MONTHLY: "Monthly",
        WEEKLY: "Weekly",
        DAILY: "Daily",
      };
      const billingUnit =
        billingUnitMap[billingType] ?? billingType.toLowerCase();
      setPricePoint(`Rs. ${price}/${billingUnit}`);
      setDisclaimerText(
        `* Continue click krne se aap ke account se Rs. 1 kat jayega. Yeh offer 24 hours ke liye valid hai jis ke baad automatically Rs. ${price}/${billingUnit} Inc. Tax deduct honge.`,
      );
      if (_msisdn || msisdn.length === 10)
        checkJazzCashUser(_msisdn || msisdn, id.toString());
      setIsLoading(false);
    } catch (error) {
      console.log("error while fetching plan", error);
      setIsLoading(false);
    }
  };

  const onMsisdnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    console.log("e::", e);
    const userInput = e.target.value;
    if (
      !userInput ||
      (userInput.length <= 10 && /^3\d{0,9}$/.test(userInput))
    ) {
      setErrorMessage("");
      setMsisdn(userInput);
    }
  };

  const onPrivacyPolicyClick = () => {
    setIsPrivacyPolicyChecked(!isPrivacyPolicyChecked);
    setErrorMessage("");
  };

  const onContinueClick = () => {
    if (msisdn.length !== 10) {
      setErrorMessage("Please enter a valid Jazz Cash number.");
      return;
    } else if (!isPrivacyPolicyChecked) {
      setErrorMessage("Please agree to the Privacy Policy to continue.");
      return;
    } else {
      checkJazzCashUser(msisdn);
    }
    setErrorMessage("");
  };

  const fetchMsisdn = async () => {
    try {
      const response = await headerEnrichmentService();
      if (response.status === 200) {
        if (response.response.msisdn)
          setMsisdn(response.response.msisdn.slice(-10));
        fetchPlan(response.response.msisdn.slice(-10));
      }
    } catch (error) {
      fetchPlan();
      console.log("error while  calling HE ", error);
    }
  };

  const checkJazzCashUser = async (msisdn: string, planId?: string) => {
    setIsLoading(true);
    try {
      const response = await checkJCUserService(msisdn);
      if (response.result) {
        setErrorMessage("You have an active JazzCash subscription");
      } else {
        const activePlanId = planId ?? resolvedPlanId;
        const url =
          Config.JazzcashUrl +
          `?msisdn=${msisdn}&utm_source=${utm_source}&source=CAMPAIGN&plan_id=${activePlanId}`;
        console.log("url::", url);
        window.location.replace(url);
      }
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <LandingJazzCash
      msisdn={msisdn}
      errorMessage={errorMessage}
      isArtworkLoading={isArtworkLoading}
      artworkUrl={artworkUrl}
      pricePoint={pricePoint}
      disclaimerText={disclaimerText}
      isLoading={isLoading}
      onMsisdnChange={onMsisdnChange}
      onPrivacyPolicyClick={onPrivacyPolicyClick}
      onContinueClick={onContinueClick}
      isPrivacyPolicyChecked={isPrivacyPolicyChecked}
    />
  );
};
export default LandingJazzCashScreen;
